import { githubUsername } from "../../githubUsername";

export const apiUrl = `https://api.github.com/users/${githubUsername}/repos`;
